import { combineReducers } from 'redux';
import Match from './../../../VCardMundial/MatchVCard/redux/matchVcard.reducer';
import Matches from './matches.reducer';
import Team from './../../../VCardMundial/TeamVCard/redux/teamVCard.reducer';
import Groups from './groups.reducer';
import Teams from './teams.reducer';
import Calendar from './calendar.reducer';

export default combineReducers({
  Calendar,
  Groups,
  Matches,
  Match,
  Teams,
  Team,
});
